module.exports = __webpack_public_path__ + "static/media/original.83990abd.jpg";